import { QueryClient } from '@tanstack/react-query';

import { GUIDE_STATUS_QUERY_KEY } from '../constants/guide-query-keys';

export const invalidateGuideQueries = async (queryClient: QueryClient): Promise<void> => {
  await queryClient.invalidateQueries({ queryKey: GUIDE_STATUS_QUERY_KEY });
};
